"use client";

import { useMediaQuery } from "@mantine/hooks";
import { BlankPage } from "@/components/partners/blank/blank-page";
import BlankMobilePage from "@/components/ui/blank-mobile-page";

export default function Page() {
  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  return (
    <>
      {isSmallScreen === true && <BlankMobilePage disabled={false} />}
      {isSmallScreen === false && <BlankPage />}
    </>
  );
}
